import { Component, HostBinding, Input, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FacetSlotDirective } from './facet-slot.directive';

@Component({
    selector: 'w-slot',
    templateUrl: './w-slot.component.html',
    host: {
        class: 'b-slot'
    },
    standalone: false
})
/*
@id w-slot
@name w-slot
@status release
@description
*/
export class WSlotComponent {
  @Input() isEdit: boolean = false; // @no-doc deprecated
  @HostBinding('class') get _class() {
    return this.isEdit ? 'b-edit-panel__slot' : 'b-view-panel__slot';
  }
}
@NgModule({
  imports: [CommonModule],
  exports: [WSlotComponent, FacetSlotDirective],
  declarations: [WSlotComponent, FacetSlotDirective]
})
export class WSlotModule { }
